import React from 'react';
import DataList from '../DataList';

const STATUS_LABELS = {
  not_due: 'Not due yet',
  due: 'Due',
  prevented: 'Leave was stopped',
  paid: 'Paid',
  historical: 'Past year',
};

const daysLeft = (row) => {
  const entitled = Number(row.entitled_days);
  const used = Number(row.used_days);
  if (!Number.isFinite(entitled) || !Number.isFinite(used)) return '';
  return Math.round((entitled - used) * 100) / 100;
};

const EmployeeLeaveBalances = ({ employee }) => {
  const apiConfig = {
    title: 'Leave balances',
    path: '/leave-balances',
    fetchEndpoint: `/hospital-portal/api/employees/leave/balances?employee_id=${encodeURIComponent(employee.employee_id)}`,
    useLocalCaching: false,
    allowAdd: false,
    allowEdit: false,
    allowExport: false,
    defaultSortFieldId: 'leave_year_start',
    defaultSortAsc: false,
    fields: [
      { name: 'balance_id', label: 'Balance', type: 'text', identifier: true, disabled: true, visible: false },
      { name: 'leave_year_start', label: 'Leave year', type: 'date', disabled: true },
      { name: 'entitled_days', label: 'Entitled days', type: 'number', disabled: true },
      { name: 'used_days', label: 'Used days', type: 'number', disabled: true },
      { name: 'sick_used_days', label: 'Sick days used', type: 'number', disabled: true },
      { name: 'allowance_status', label: 'Allowance', type: 'text', disabled: true },
      { name: 'allowance_amount', label: 'Allowance amount', type: 'number', disabled: true },
    ],
  };

  const columns = [
    { name: 'ID', selector: (row) => row.balance_id, identifier: true, omit: true },
    {
      id: 'leave_year_start',
      name: 'Leave year',
      selector: (row) => row.leave_year_start,
      sortable: true,
      type: 'date',
    },
    { name: 'Entitled days', selector: (row) => row.entitled_days, sortable: true },
    { name: 'Used days', selector: (row) => row.used_days, sortable: true },
    { name: 'Days left', selector: (row) => daysLeft(row), sortable: true },
    {
      name: 'Allowance',
      selector: (row) => (row.has_voucher ? 'Paid' : (STATUS_LABELS[row.allowance_status] || row.allowance_status)),
      sortable: true,
    },
    { name: 'Amount', selector: (row) => row.allowance_amount, sortable: true, right: true },
  ];

  return <DataList apiConfig={apiConfig} columns={columns} />;
};

export default EmployeeLeaveBalances;
